<template>
  <div class="purchaseUnit">
     <div class="content-container">
      <div class="titieMian">
        <div class="title-container">购销单位</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>类型：</span>
            <el-select v-model="type" filterable placeholder="请选择" size="small" @change="changeType">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>输入查询：</span>
            <el-input placeholder="请输入关键字" v-model="keyword" prefix-icon="el-icon-search" size="small" type="text" :maxlength="20" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" class="search-input" clearable>
            </el-input>
          </div>
          <div class="select-container-box"  v-if="canEditAll=true">
            <el-button size="small" type="info" plain @click="search(1)" class="query" >查询</el-button>
            <el-button size="small" type="info" plain @click="goAdd" class="add" v-if="edit">增加</el-button>
            <!-- <el-button size="small" type="info" plain @click="goSync" class="tongbu" v-if="$store.state.curCompany.isQlwVersion==true && edit">同步</el-button> -->
             
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table
         :data="circulationAList.list"
          @row-dblclick="dblclickIntoEdit"
          style="width:100%" 
          size="medium" 
          :default-sort="{prop: 'date', order: 'descending'}">
           <i slot="empty" style="font-style:normal">暂无数据</i>
          <el-table-column
           prop="typeName"
           label="单位类型" 
           :filters="getFilterTypeList"
          :filter-method="filterHandler"
           align="center"
           show-overflow-tooltip 
          >
          <!-- <template slot-scope="scope">
           <span>{{findNameById(scope.row.type,typeList)}}</span>
          </template> -->
          
          </el-table-column>
          <el-table-column 
          prop="name" 
          label="公司名称"
          :filters="getFilterNameList"
          :filter-method="filterHandler"
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="leader" 
          label="联系人" 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="address" 
          label="地址" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column label="操作栏" align="center"  >
            <template slot-scope="scope">
              <span @click="baseSettingEdit(scope.$index, scope.row)" class="content-edit">{{edit ? "编辑" : "查看"}}</span>
              <span @click="baseSettingDelete(scope.$index, scope.row)" class="content-del" v-if="edit">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
  </div>
</template>


<script>
import { MessageBox, Message } from "element-ui";
import PageChange from "../../common/PageChange";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "purchaseUnit",
  mixins: [mixins],
  components: {
    PageChange
  },
  data() {
    return {
      typeList: [
        {
          id: "",
          name: "全部"
        },
        {
          id: 1,
          name: "销售单位"
        },
        {
          id: 2,
          name: "供货单位"
        },
        {
          id: 3,
          name: "购销单位"
        }
      ],
      type: "",
      keyword: "", // 关键字
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      }
    };
  },
  methods: {
    ...mapActions(modules.circulationBusiness, [
      "getCirculationAData", //查询数据
      "delCirculationB", //删除数据
      "syncQlw" //同步
    ]),
    // 字段筛选过滤
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    //查询
    search(pageNum) {
      let obj = {
        type: this.type,
        pageIndex: (this.pageInfo.pageNumber = pageNum || 1),
        pageSize: this.pageInfo.pageSize,
        queryString: this.keyword
      };
      this.getCirculationAData(obj)
        .then(rsp => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          console.dir(err);
        });
    },
    //同步
    goSync() {
      this.syncQlw()
        .then(rsp => {
          if (rsp.status == 200) {
            this.$message({
              message: "同步成功",
              type: "success"
            });
            this.search();
          }
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
        });
    },
    // 添加
    goAdd() {
      this.$router.push({
        name: "addPurchaseUnit"
      });
    },
    // 切换类型
    changeType(e) {
      storage.set("typeName", e);
      this.search(1);
    },
    // 双击进入编辑页
    dblclickIntoEdit(row, event) {
      this.$router.push({
        name: "editPurchaseUnit",
        query: {
          id: row.id,
        }
      });
    },
    // 通过名字找id
    findNameById(id, arr) {
      let obj = arr.find(item => {
        return item.id == id;
      });
      return obj.name;
    },
    //编辑
    baseSettingEdit(index, row) {
      this.$router.push({
        name: "editPurchaseUnit",
        query: {
          id: row.id,
        }
      });
    },
    //删除
    baseSettingDelete(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.delCirculationB(row.id);
          this.search(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
        });
    }
  },
  computed: {
    ...mapState(modules.circulationBusiness, ["circulationAList"]),
    //需要筛选的字段
    getFilterTypeList() {
      const res = new Map();
      let fiterList = this.circulationAList.list
        .map(m => ({
          value: m.typeName,
          text: m.typeName
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    //需要筛选的字段
    getFilterNameList() {
      const res = new Map();
      let fiterList = this.circulationAList.list
        .map(m => ({
          value: m.name,
          text: m.name
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    }
  },
  mounted() {
    console.log(121299, this.curCompany, 111);
    let a = storage.get("typeName");
    let b = this.typeList.find(f => f.id == a);
    if (b) {
      this.type = b.id;
    } else if (this.typeList.length > 0) {
      this.type = this.typeList[0].id; //默认选中第一个
    }
    this.search(1);
  }
};
</script>

<style lang="stylus">

</style>
